/**
 * GetTopNotificationsQuery - Fetches top notifications for header widget
 * Follows MediatR pattern (Query + Handler in same file)
 */

import type { IQuery, IQueryHandler, IHttpClient, BaseApiResponse } from '@/application/core';
import type { TopNotificationsResponse, NotificationItem } from './notifications.types';
import { toCamelCase } from '@/utils/caseTransform';

// ============================================================================
// Query (Request)
// ============================================================================

export class GetTopNotificationsQuery implements IQuery<TopNotificationsResponse> {
  readonly type = 'GetTopNotificationsQuery' as const;
}

// ============================================================================
// Handler
// ============================================================================

export class GetTopNotificationsQueryHandler
  implements IQueryHandler<GetTopNotificationsQuery, TopNotificationsResponse>
{
  constructor(private readonly httpClient: IHttpClient) {}

  async handle(_query: GetTopNotificationsQuery): Promise<TopNotificationsResponse> {
    const response = await this.httpClient.get<BaseApiResponse<any>>(
      '/api/v1/notifications/top'
    );

    if (!response.succeeded) {
      throw new Error(response.message || 'Failed to fetch notifications');
    }

    const data = response.data;

    // Transform notification items (handle snake_case -> camelCase)
    const notifications: NotificationItem[] = (
      data.notifications ??
      data.Notifications ??
      []
    ).map((n: any) => toCamelCase(n));

    return {
      notifications,
      newCount: data.newCount ?? data.new_count ?? data.NewCount ?? 0,
    };
  }
}
